import { connect } from 'react-redux';
import moment from 'moment';
import HeaderNew from '../../../components/PageStructure/Header/HeaderNew';
import { logoutAndRedirect } from '../../../actions/global/auth';
import globals from '../../../globals/communityGlobals';
import { getSettings } from '../../../actions/entities';

const locale = globals.getArea('accountLogin');

const mapStateToProps = ({ global: { auth }, router: { location }, areas }) => {
  const { pathname } = location;
  return {
    isAuthenticated: auth.isAuthenticated,
    name: auth.displayName || auth.loginName,
    currentPathname: pathname,
    selectedDate: moment(areas.dailyPlanning.selectedDate).format('dddd Do MMM YYYY'),
  };
};

const mapDispatchToProps = dispatch => ({
  logoutAndRedirect: () => {
    dispatch(logoutAndRedirect({ success: locale.getMsg('logoutSuccess') }));
  },
  getAppSettings: kv => {
    dispatch(getSettings(kv));
  },
});

const HeaderContainerNew = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false },
)(HeaderNew);

export default HeaderContainerNew;
